export const submenuMyCampus = [
  {
    value: 'udcLessons',
    link: '/campus/udcLessons',
    text: 'Mis Clases UDC'
  },
  {
    value: 'myAcademies',
    link: '/campus/myAcademies',
    text: 'Mis Academias'
  },
  {
    value: 'myCourses',
    link: '/campus/myCourses',
    text: 'Mis Cursos Mayahii'
  },
  {
    value: 'myBooks',
    link: '/campus/myBooks',
    text: 'Mis Libros'
  }
];
